import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

export function pageHeader(){
    let pageHeaderSlider = new Swiper(".page-header__slider", {
        spaceBetween: 0,
        slidesPerView:1,
        effect: "fade",
        loop:true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: ".page-header__next",
            prevEl: ".page-header__prev",
        },
        pagination: {
            el: ".page-header__pagination",
            clickable: true,
        },
    });
    return pageHeaderSlider
}